var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsRepair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0012 11.0002L6.00116 6.00021M5.00116 7.50021L7.50116 5.00021L4.50116 3.50021L3.50116 4.50021L5.00116 7.50021ZM19.9762 8.97521C20.4563 8.49552 20.7866 7.8866 20.9268 7.22258C21.0671 6.55856 21.0113 5.86808 20.7662 5.23521L19.3442 6.65721H17.3442V4.65721L18.7662 3.23521C18.1332 2.98955 17.4425 2.93327 16.7782 3.07322C16.1139 3.21318 15.5046 3.54333 15.0246 4.02345C14.5446 4.50357 14.2145 5.11293 14.0747 5.7773C13.9349 6.44166 13.9914 7.13235 14.2372 7.76521L7.76716 14.2362C7.1343 13.9904 6.44361 13.934 5.77925 14.0738C5.11488 14.2136 4.50552 14.5436 4.0254 15.0236C3.54528 15.5036 3.21513 16.1129 3.07518 16.7773C2.93522 17.4416 2.9915 18.1323 3.23716 18.7652L4.65816 17.3432H6.65816V19.3432L5.23616 20.7652C5.86891 21.0109 6.55945 21.0672 7.22366 20.9274C7.88788 20.7877 8.49712 20.4577 8.97719 19.9779C9.45726 19.498 9.78743 18.8889 9.92752 18.2248C10.0676 17.5606 10.0115 16.8701 9.76616 16.2372L16.2382 9.76521C16.8708 10.0099 17.5608 10.0655 18.2245 9.92523C18.8881 9.78498 19.4966 9.45493 19.9762 8.97521Z",
    stroke: "#027A48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7969 14.4999L17.4009 20.1039C17.5263 20.2295 17.6752 20.3292 17.8392 20.3972C18.0031 20.4652 18.1789 20.5002 18.3564 20.5002C18.5339 20.5002 18.7096 20.4652 18.8736 20.3972C19.0375 20.3292 19.1865 20.2295 19.3119 20.1039L20.1039 19.3119C20.2295 19.1865 20.3292 19.0375 20.3972 18.8736C20.4652 18.7096 20.5002 18.5339 20.5002 18.3564C20.5002 18.1789 20.4652 18.0031 20.3972 17.8392C20.3292 17.6752 20.2295 17.5263 20.1039 17.4009L14.4999 11.7969",
    stroke: "#027A48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsRepair1);
export default __webpack_public_path__ + "static/media/hugeicons_repair (1).3a65a8ca3b8a808f069877bcc316e9b3.svg";
export { ForwardRef as ReactComponent };